export default __webpack_public_path__ + "static/media/include_17@3x.0d967a88.jpg";